<dss-libs-ui-table-skeleton [columns]="tableColumns" />
